var app = angular.module('leonardo');

var PropertyTasksFilters = function (
  $scope,
  $controller,
  CategoryCacheRestService,
  ReportService,
  PermissionService,
  AccountUserService,
) {


$controller('FiltersBaseController', { $scope: $scope });


$scope.categories = [];


CategoryCacheRestService.getCategories().then(function(response) {
  if (response && response.length > 0) {
    $scope.categories = response.map(function(category) {
      return { id: category.id, name: category.name }; 
    });
  } else {
    console.warn('No categories found or invalid response');
    $scope.categories = []; 
  }
}, function(error) {
  console.error('Failed to fetch categories:', error);
  $scope.categories = []; 
});

$scope.$watch('categories', function(newValue) {
  if (newValue.length > 0) {
    const categoryFilter = $scope.filters_options.find(option => option.id === 'category');
    if (categoryFilter) {
      categoryFilter.options = newValue;
    }
  }
});


  $scope.filters_options = [
    {
      id: 'category',
      name: 'Category',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'All Categories',
      condition: true,
      options:$scope.categories,
      conflicts: ['sector']
    },
    {
      id: 'priority',
      name: 'Priority',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'All Priorities',
      condition: true,
      options: ReportService.PRIORITY_OPTIONS,
      conflicts: []
    },
    {
      id: 'role',
      name: 'Role',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      options: $scope.authDataService.getRolesValid(),
      condition: PermissionService.isOwner(),
      conflicts: []
    },
    {
      id: 'account_users_assigned',
      name: 'Assigned user',
      label: null,
      inline: false,
      type: 'options',
      multiple: true,
      placeholder: 'Assigned user',
      modeUser: true,
      service : AccountUserService,
      serviceParams: {disable_pagination: true, essential: true, user_is_active: true, property: $scope.filterService.getFilter('property')},
      serviceFunction: AccountUserService.getAvailableToAssign,
      condition: true,
      conflicts: ['property']
    }
  ];

  $scope.$watch('property', function (newValue, oldValue) {
    if (newValue !== oldValue) {
      var filters = angular.copy($scope.filters_options);
      angular.forEach(filters, function(filter){
        if (['account_users_assigned'].includes(filter.id)){
          filter.serviceParams = { property: newValue,disable_pagination: true, essential: true, user_is_active: true};
          $scope.filters_options = filters;
        }
      });
    }
  });

  $scope.filterService.showFilters(['category', 'priority','account_users_assigned']);
};

app.controller('PropertyTasksFilters', [
  '$scope',
  '$controller',
  'CategoryCacheRestService',
  'ReportService',
  'PermissionService',
  'AccountUserService',
  PropertyTasksFilters
]);